import { useLazyQuery, useMutation } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useUser from "hooks/useUser";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import Add from "./Add";
const { vendors: { GET_STORES, SEARCH_VENDORS } } = queries;
const { vendors: { ADD_STORE } } = mutations;
const usePrepareComponent = () => {
    const history = useHistory();
    const [selectedVendorId, setSelectedVendorId] = useState();
    const { isAdmin, isEditor } = useUser();
    const [addStore, { loading: addStoreLoading }] = useMutation(ADD_STORE, { refetchQueries: [GET_STORES] });
    const [searchVendors, { data: searchVendorsData, loading: searchVendorsLoading }] = useLazyQuery(SEARCH_VENDORS);
    const onCancel = () => {
        history.push("/vendors/stores");
    };
    // When a Vendors is selected, fetch its data and update the form values
    const onSelectVendorId = (id) => {
        setSelectedVendorId(id ?? "");
    };
    const onGetVendorsSuggestions = ({ inputValue }) => {
        searchVendors({
            variables: {
                searchVendorsInput: {
                    name: inputValue
                }
            }
        });
    };
    const onSave = (itemUpdate) => {
        if (!itemUpdate.vendorId) {
            return;
        }
        const itemAdd = {
            ...itemUpdate,
            isInternationalShipping: true,
            isPublished: false,
            vendorId: itemUpdate.vendorId
        };
        addStore({
            onCompleted: ({ addStore: { id } }) => {
                history.push(`/vendors/stores/${id}`);
            },
            variables: {
                storeAddInput: itemAdd
            }
        });
    };
    return {
        isAdmin,
        isEditor,
        isSaveLoading: addStoreLoading,
        isVendorsSuggestionsLoading: searchVendorsLoading,
        onCancel,
        onGetVendorsSuggestions,
        onSave,
        onSelectVendorId,
        selectedVendorId,
        vendors: searchVendorsData?.searchVendors ?? []
    };
};
export default prepareComponent(usePrepareComponent)(Add);
